import { createStyles, makeStyles } from '@mui/styles'

export const useStyles = makeStyles(() =>
  createStyles({
    container: {
      borderRadius: '5px',
      height: '55vh',
      minHeight: '45vh',
      maxHeight: '80vh',
      width: '87%',
      overflowX: 'hidden',
      overflowY: 'scroll',
      border: '0.5px solid #004BB1',
      background: 'white',
      '&::-webkit-scrollbar': {
        width: '10px',
        backgroundColor: '#F5F5F5'
      },
      '&::-webkit-scrollbar-track': {
        boxShadow: `inset 0 0 6px rgba(0, 0, 0, 0.3)`,
        backgroundColor: '#F5F5F5',
        borderRadius: '5x'
      },
      '&::-webkit-scrollbar-thumb': {
        borderRadius: '5px',
        backgroundImage:
          '-webkit-gradient(linear,left bottom,left top,color-stop(0.44, rgb(122,153,217)),color-stop(0.72, rgb(73,125,189)),color-stop(0.86, rgb(28,58,148)));'
      }
    },
    flexContainer: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      flexDirection: 'column',
      maxWidth: '500px',
      backgroundColor: 'white',
      minHeight: '80vh',
      borderRadius: '10px'
    }
  })
)
